import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH VOD TO EDIT ********************
export const fetchVodDetails = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_VOD_DETAILS_LOADING,
			payload: true
		});

		const url = `/vod/${id}`;

		const response = await services.get(url);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_VOD_DETAILS_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_VOD_DETAILS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
